import { XIcon } from 'lucide-react';

interface FileNameChipProps {
  fileName: string;
  onRemove?: () => void;
  showRemove?: boolean;
  size?: 'xs' | 'sm';
}

export function FileNameChip({
  fileName,
  onRemove,
  showRemove = true,
  size = 'xs',
}: FileNameChipProps) {
  const sizeClasses = {
    xs: 'text-xs px-2 py-1',
    sm: 'text-sm px-3 py-1.5',
  };

  return (
    <div
      className={`flex items-center gap-1.5 bg-blue-100 text-blue-800 font-semibold rounded-md overflow-hidden max-w-full ${sizeClasses[size]}`}
    >
      <span className="truncate min-w-0">{fileName}</span>
      {showRemove && onRemove && (
        <button
          type="button"
          className="hover:text-red-600 hover:scale-110 transition-[color,transform] duration-200 flex-shrink-0"
          onClick={onRemove}
          title="Remove file"
          aria-label="Remove file"
        >
          <XIcon className="w-3.5 h-3.5" strokeWidth={2.5} />
        </button>
      )}
    </div>
  );
}

export default FileNameChip;
